import styled from "styled-components"

export const StyledErrorMessage = styled.div`
    font-size: 12px;
    color: red;
`;
